// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"385de427","135":"78aa82e3","193":"b22b4ac4","579":"f86df4fe","642":"7b666e11","777":"978fe4b0","779":"e750f2e1","875":"b37fad64"}[chunkId] + ".chunk.js";
};